import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum DelegationAddFromAllMileagesErrorType {
  NO_MILEAGES_AVAILABLE = "NO_MILEAGES_AVAILABLE",
}

export type DelegationAddFromAllMileagesNoMileagesAvailableError =
  DataLoadError<
    DelegationAddFromAllMileagesErrorType.NO_MILEAGES_AVAILABLE,
    {}
  >;

type DelegationAddFromAllMileagesError =
  | DataLoadDefaultErrors
  | DelegationAddFromAllMileagesNoMileagesAvailableError;

export default DelegationAddFromAllMileagesError;
